export default __webpack_public_path__ + "static/media/auth-bg-1.ad76ca80.jpg";